import { http, HttpResponse } from "msw";
import type { Hotels_GetOffers_GetOffersQueryResponse_Success } from "../../swagger-types/v1/index.js";
import { apiPaths } from "../../api-paths.js";

const offersEndpoint = `*${apiPaths.hotelOffers.get}`;
const trackEndpoint = `*${apiPaths.hotelOffers.track}`;

export const hotelExternalOffersHandlers = {
  "200": [
    http.get(offersEndpoint, async () =>
      HttpResponse.json(
        {
          offers: [
            {
              hotelId: 125866,
              requestId: "dd22bc20-948a-4213-9ab7-dfdc7e398d83",
              offers: [
                {
                  roomName: "Room, 1 King Bed, Accessible (Shower) - Save 15%",
                  url: "https://www.google.com/",
                  boardCode: "RoomOnly",
                  rate: {
                    currencyCode: "USD",
                    base: 1530,
                    hotelFees: 102.14,
                    tax: 236.68,
                    nightly: 765,
                  },
                  cancellationPolicy: {
                    type: "NonRefundable",
                    deadline: null,
                  },
                  provider: {
                    name: "Expedia",
                    logoUrl: "https://i.fih.io/provider/svg/exp.svg",
                  },
                },
                {
                  roomName: "Room, 1 King Bed",
                  url: "https://deals.vio.com?checkIn=2025-08-25&checkOut=2025-08-27&curr=USD&epv=papiV1&esd=ZrSd6mglK6sZ9izOUtmCBB8DZzeASJ1pJMtUkgXmk1XShgA7HEYZzyOE6w%3D%3D&forceCurrencyChange=1&forceLanguageChange=1&hotelId=1606133&label=anonymousId%3Ddd22bc20-948a-4213-9ab7-dfdc7e398d83&lang=en&optimizeRooms=0&profile=YXBpQWZmaW&rooms=2&sig=cf3f9351e8541320a199ab9ebc387c23fa6c36220aead0ce3e189441ee1c7fb2373232363438373030&sig-iss=sapi&turl=https%3A%2F%2Fwww.vio.com%2FHotel%2FSearch&userCountry=PL&utm_source=tro",
                  boardCode: "RoomOnly",
                  rate: {
                    currencyCode: "USD",
                    base: 1530,
                    hotelFees: 102.14,
                    tax: 236.68,
                    nightly: 765,
                  },
                  cancellationPolicy: {
                    type: "NonRefundable",
                    deadline: null,
                  },
                  provider: {
                    name: "Vio.com",
                    logoUrl: "https://i.fih.io/provider/svg/fht.svg",
                  },
                },
                {
                  roomName: "Room, 1 King Bed - Save 15%",
                  url: "https://deals.vio.com?lbl=utm_source%3Dtro%26label%3DanonymousId%253Ddd22bc20-948a-4213-9ab7-dfdc7e398d83&ofd=book_uri%3Dcampaign_reference%253D1101lkd5e%2526destination%253Dhttps%25253A%25252F%25252Fwww.hotels.com%25252FHotel-Search%25253Ftpid%25253D3180%252526mpe%25253D1755521910%252526endDate%25253D2025-08-27%252526adults%25253D2%252526locale%25253Den_IE%252526chid%25253D0668a955-7c9c-4f1a-814e-be5da497560a%252526eapid%25253D25%252526startDate%25253D2025-08-25%252526mpd%25253DUSD%252526mpc%25253D102.14%252526mpn%25253D200164138%252526currency%25253DUSD%252526rateplanid%25253D397281864%252526mpm%25253D24%252526mpp%25253D1%252526mpo%25253DEC%252526selected%25253D3505139%252526mpb%25253D236.68%252526mpa%25253D1530.00%252526cur%25253DUSD%252526startDate%25253D2025-08-25%252526endDate%25253D2025-08-27%26ci%3D2025-08-25%26co%3D2025-08-27%26hid%3D1606133%26loc%3Den%26ds%3Df&oid=oWY8Gcd9MoA0&pid=ian&sid=54d96880-497f-42fc-9a7b-1ade2f70a903&sig=d6ec9815d9c24253e2869b68aa24b95959ba48143dc97731b41378343ae6687d373232363438373030&sig-iss=sapi&turl=https%3A%2F%2Fr.vio.com%3Fsig%3D895bd18f5dbe21553707ab9486af5a7b000bf2528f662f25b4b7ae13a4466387383031363333333238%26sig-iss%3Draa-api",
                  boardCode: "RoomOnly",
                  rate: {
                    currencyCode: "USD",
                    base: 1530,
                    hotelFees: 102.14,
                    tax: 236.68,
                    nightly: 765,
                  },
                  cancellationPolicy: {
                    type: "NonRefundable",
                    deadline: null,
                  },
                  provider: {
                    name: "Hotels.com",
                    logoUrl: "https://i.fih.io/provider/svg/ian.svg",
                  },
                },
              ],
            },
          ],
        } satisfies Hotels_GetOffers_GetOffersQueryResponse_Success,
        { status: 200 },
      ),
    ),
    http.post(trackEndpoint, async () => HttpResponse.json({}, { status: 200 })),
  ],
  "200Empty": [
    http.get(offersEndpoint, async () =>
      HttpResponse.json(
        {
          offers: [],
        } satisfies Hotels_GetOffers_GetOffersQueryResponse_Success,
        { status: 200 },
      ),
    ),
    http.post(trackEndpoint, async () => HttpResponse.json({}, { status: 200 })),
  ],
};
